import { configurationSettings } from '../configuration/configuration-settings';
export const getCacheDuration = (cacheKey) => {
    const cacheDuration = configurationSettings.data.cache.durations[cacheKey];
    if (cacheDuration === undefined)
        throw new Error(`Cannot find cache duration for key: ${cacheKey}.`);
    return cacheDuration;
};
